{
    "details": {
        "file_details": "File details",
        "history": "History"
    },
    "keys": {
        "file_number": "File #",
        "total_amount": "Amount",
        "initial_amount": "Initial amount",
        "final_amount": "Final amount",
        "status": "Status",
        "label": "Terminal label",
        "currency": "Currency",
        "bank_code": "Bank code",
        "pan": "Card number",
        "opening_date": "Opening",
        "closing_date": "Closing",
        "expiration_date": "File expiration",
        "card_type": "Issuer",
        "rank": "Rank",
        "contract": "Contract"
    },
    "filter": {
        "placeholder": {
            "file_number": "Filter by file number",
            "label": "Filter by terminal label",
            "card_type": "Filter by issuer",
            "pan": "Filter by card number"
        }
    },
    "history": {
        "empty_results": "No history results found"
    },
    "status": {
        "OPENED": "Opened",
        "CLOSED_WITH_DEBIT": "Closed with debit",
        "CLOSED_NO_DEBIT": "Closed no debit",
        "CLOSED_EXPIRED": "Closed expired",
        "ERROR_INITIALIZATION": "Opening error",
        "UNKNOWN": "Unknown"
    },
    "event_type": {
        "PREAUTHORIZATION": {
            "name": "Rental file opening",
            "success": "Pre-authorization accepted",
            "error": "Pre-authorization rejected"
        },
        "PREAUTHORIZATION_CANCELLATION": {
            "name": "Rental file opening",
            "success": "Rental file cancelled",
            "error": "Rental file cancelled"
        },
        "DOCUMENT_REQUEST": {
            "name": "Document request",
            "success": "Document request accepted",
            "error": "Document request rejected"
        },
        "ADDITIONAL_INVOICE": {
            "name": "Additional billing",
            "success": "Additional billing accepted",
            "error": "Additional billing rejected"
        },
        "PAYMENT": {
            "name": "Rental file closing",
            "success": "Closing with debit",
            "error": "Closing without debit",
            "expired": "Rental file expired"
        },
        "REMOTE_COLLECTION": {
            "name": "Remitted to bank",
            "success": "",
            "error": ""
        },
        "UNKNOWN": {
            "name": "Unknown",
            "success": "No information available.",
            "error": "No information available."
        }
    }
}